import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

//
import SERVICELIST from "../../../assets/data/service-list";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function AllServiceList() {
  const { t } = useTranslation();

  return (
    <StyledAllServiceList>
      <div className="container">
        <div className="all-service-list__wrap">
          <ul className="all-service-list__grid">
            {SERVICELIST.map((i) => (
              <li className="all-service-list__item" key={i.id}>
                <div className="all-service-list__item__image">
                  <ImageOverlayCard
                    image={i.img}
                    title={t(i.title)}
                    alt={t(i.title)}
                    to={i.to}
                  />
                </div>
                <div className="all-service-list__item__content">
                  <p>{t(i.text)}</p>
                  <Link to={i.to} className="hover-underline">
                    <p>{t("serviceSingleLinkText")}</p>
                    <i className="icon icon-long-arrow-alt-right"></i>
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </StyledAllServiceList>
  );
}

const StyledAllServiceList = styled.section`
  padding: 140px 0;

  .all-service-list {
    &__grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 48px 28px;
      align-items: start;
    }

    &__item {
      position: relative;
      display: flex;
      min-width: 0;
      flex-direction: column;

      &__image {
        position: relative;
        width: 100%;
        aspect-ratio: 1 / 1.18;
        overflow: hidden;
        border: 1px solid var(--border);

        & > * {
          width: 100%;
          height: 100%;
        }
      }

      &__content {
        position: relative;
        z-index: 2;
        margin-top: 16px;

        & > p {
          color: var(--text);
          font-size: var(--fs-body-sm);
          font-style: normal;
          font-weight: var(--fw-regular);
          line-height: var(--lh-body);
          margin-bottom: 32px;
        }

        a {
          display: flex;
          align-items: center;
          gap: 12px;
          width: max-content;

          p {
            color: var(--light-blue);
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            transition: color 0.3s;
          }

          i {
            background-color: var(--light-blue);
            width: 18px;
            height: 18px;
          }

          &::after {
            background-color: var(--light-blue);
          }

          &:hover {
            i {
              transform: translateX(45px);
              opacity: 0;
            }

            &::after {
              width: calc(100% - 30px);
            }
          }
        }
      }
    }

    @media (max-width: 992px) {
      &__grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    @media (max-width: 640px) {
      &__grid {
        grid-template-columns: 1fr;
        row-gap: 40px;
      }
    }
  }
`;
